<template>
    <div id="tryout-group">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Live Class' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Live Class</h3>

        <v-card>
            <v-card-title>
                Daftar Live Class
                <v-spacer></v-spacer>
                <v-btn
                    class="align-center text-body-2 blew white--text mr-2"
                    text
                    id="live_class_tambah"
                    @click="reportLiveClass()"
                >
                    <v-icon small class="mr-2">mdi-chart-bell-curve</v-icon>
                    Lihat Laporan
                </v-btn>

                <!-- <v-btn
          class="align-center text-body-2 blew white--text mr-1"
          text
          id="live_class_tambah"
          @click="dialogUploadLiveClass = true"
          ><v-icon small class="pr-2">mdi-cloud-upload</v-icon>
          Upload Live Class
        </v-btn>

        <v-btn
          class="align-center text-body-2 blew white--text"
          text
          id="live_class_tambah"
          @click="createliveClass()"
          ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
          Live Class
        </v-btn> -->

                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="blew"
                            dark
                            depressed
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon small class="mr-2"
                                >mdi-dots-vertical</v-icon
                            >
                            Live Class
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item @click="createliveClass()">
                            <v-list-item-title
                                class="blew--text font-weight-500"
                            >
                                Add New
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="dialogUploadLiveClass = true">
                            <v-list-item-title
                                class="blew--text font-weight-500"
                            >
                                Upload Files
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>

            <v-divider />

            <app-datatable
                :items="liveClasses"
                :headers="headers"
                :hasMultiSearch="true"
                :has-custom-pagination="true"
                :has-custom-search="true"
                :has-action="true"
                :hasOpenNewTab="true"
                :custom-pagination-total-items="total_data"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="total_pages"
                :custom-pagination-sort-mode="pagination.sortMode"
                :customWidth="true"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="editliveClass()"
                v-on:deleteOnFilter="delByOneFilter($event)"
                v-on:deleted="
                    dialogConfirm.function = $event;
                    dialogConfirm.title = 'Hapus Live Class';
                    dialogConfirm.subtitle =
                        'Apakah anda yakin akan menghapus Live Class ini?';
                    dialogConfirm.open = true;
                "
                v-on:doSearch="
                    filters = $event;
                    doFilter();
                "
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:openNewTab="openNewTab($event)"
            />
        </v-card>

        <v-dialog v-model="dialogConfirm.open" persistent max-width="450">
            <dialog-confirm
                :title="dialogConfirm.title"
                :subtitle="dialogConfirm.subtitle"
                @close="dialogConfirm.open = false"
                @confirm="
                    deleteliveClass(dialogConfirm.function);
                    dialogConfirm.open = false;
                "
            />
        </v-dialog>

        <v-dialog v-model="dialogSucessUpload" persistent max-width="410px">
            <dialog-success-upload
                :live-class-total="liveClassData.length"
                :live-class-total-error-excel="liveClassTotalErrorExcel"
                @finish="finishUpload()"
                @edit="
                    dialogSucessUpload = false;
                    dialogExcelError = true;
                "
            />
        </v-dialog>

        <app-upload-liveclass
            v-if="dialogUploadLiveClass"
            @closeDialog="dialogUploadLiveClass = false"
            @uploadProcess="uploadRowValidation($event)"
            @successUploadExcel="successUploadExcel"
        ></app-upload-liveclass>

        <v-dialog v-model="dialogExcelValidation" persistent max-width="360">
            <dialog-upload-validation
                :live-class-total="liveClassData.length"
                :live-class-total-check-row="liveClassTotalCheckRow"
            />
        </v-dialog>

        <v-dialog
            v-model="dialogExcelError"
            persistent
            scrollable
            max-width="870"
        >
            <dialog-excel-error-upload
                :live-class-total-error-excel="liveClassTotalErrorExcel"
                :live-class-data="liveClassData"
                :live-class-excel-error="liveClassExcelError"
                :type-error="type_error"
                @close="finishUpload()"
            />
        </v-dialog>

        <v-dialog v-model="dialogLoadingUpload" persistent max-width="370">
            <dialog-upload-progress
                :live-class-total="liveClassData.length"
                :live-class-total-check-row="liveClassTotalCheckRow"
                :progress-upload-presentation="progressUploadPresentation"
            />
        </v-dialog>

        <v-dialog
            v-model="dialogConfirmErrorUpload"
            persistent
            max-width="330px"
        >
            <dialog-confirm-session
                @close="clearSessionErrorUpload()"
                @confirm="getSessionErrorUpload()"
            />
        </v-dialog>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import itembankService from "@/modules/itembank/services/itembank.js";
import LiveClassService from "@/modules/live_class/services/liveclass.js";
import Moment from "moment";
import Upload from "@/modules/live_class/components/Upload";
import DialogExcelErrorUpload from "./DialogExcelErrorUpload.vue";
import DialogUploadProgress from "./DialogUploadProgress.vue";
import DialogUploadValidation from "./DialogUploadValidation.vue";
import DialogSuccessUpload from "./DialogSuccessUpload.vue";
import DialogConfirmSessionUpload from "./DialogConfirmSessionUpload.vue";
import DialogConfirm from "@/modules/global/components/DialogConfirm";

export default {
    name: "live-class",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
        "app-upload-liveclass": Upload,
        "dialog-excel-error-upload": DialogExcelErrorUpload,
        "dialog-upload-progress": DialogUploadProgress,
        "dialog-upload-validation": DialogUploadValidation,
        "dialog-success-upload": DialogSuccessUpload,
        "dialog-confirm-session": DialogConfirmSessionUpload,
        "dialog-confirm": DialogConfirm,
    },

    data: function () {
        return {
            liveClasses: [
                {
                    id: 1,
                    data: {
                        title: "Pendalaman Materi Persamaan Linear",
                        description: "Pendalaman Materi Persamaan Linear",
                        subject: "Matematika",
                        mapel: 1,
                        join_code: "",
                        is_private: false,
                        grade: [11, 12],
                        url: null,
                        level: "SMA",
                        grade: "10",
                        created_at: Moment(1608209700000).format("YYYY-MM-DD"),
                    },
                },
            ],
            selectedRow: null,
            isLoading: false,
            search: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: [
                { text: "Nama", value: "name", width: "250" },
                { text: "Deskripsi", value: "description", width: "250" },
                { text: "Subject", value: "subject", width: "150" },
                { text: "Jenjang", value: "level", width: "100" },
                { text: "Kelas", value: "grade", width: "100" },
                { text: "Created At", value: "createdAt", width: "120" },
                { text: "Aksi", value: "actions", width: "100" },
            ],
            headersKey: [
                "name",
                "description",
                "subject",
                "level",
                "grade",
                "createdAt",
            ],
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
            search: "",
            tableKey: "",
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            filters: [],
            total_data: 0,
            total_data_per_page: 10,
            total_pages: 0,
            params: {
                page: 1,
                per_page: 10,
                name: "",
                description: "",
                sort: "",
                subject: "",
                jenjang: "",
                grades: "",
            },
            dialogUploadLiveClass: false,
            dialogLoadingUpload: false,
            dialogExcelValidation: false,
            dialogExcelError: false,
            dialogSucessUpload: false,
            dialogConfirmErrorUpload: false,
            liveClassData: [],
            liveClassExcelError: [],
            liveClassTotalRow: 0,
            liveClassTotalCheckRow: 0,
            liveClassTotalErrorExcel: 0,
            progressUploadPresentation: 0,
            type_error: "validation_excel",
            teacherList: [],
            level: ["SMA", "SMP", "SD"],
            package_type: ["FREE", "PREMIUM"],
        };
    },

    mounted: function () {
        var context = this;
        itembankService.getListMataPelajaran(function (result) {
            if (result.success) {
                localStorage.setItem("mapels", JSON.stringify(result.data));
                result.data.forEach(function (item) {
                    context.items.push(item);
                });
            }
        });
        this.fetchData();
        this.getTeachers();
        this.checkSessionErrorUpload();
    },

    watch: {
        search() {
            this.fetchData();
        },
        pagination() {
            this.fetchData();
        },
    },

    methods: {
        fetchData: function () {
            var context = this;
            this.isLoading = true;

            this.params = {
                page: context.pagination.currentPage,
                per_page: context.pagination.perPage,
                name: "",
                description: "",
                sort: "",
                subject: "",
                jenjang: "",
                grades: "",
            };

            if (this.filters.length > 0) {
                this.filters.forEach((filter, index) => {
                    if (filter.key.value === "name") {
                        this.params.name = filter.value;
                    }
                    if (filter.key.value === "description") {
                        this.params.description = filter.value;
                    }
                    if (filter.key.value === "grade") {
                        this.params.grades = filter.value;
                    }
                    if (filter.key.value === "level") {
                        this.params.jenjang = filter.value;
                    }
                    if (filter.key.value === "subject") {
                        this.params.subject = filter.value;
                    }
                });
            }

            LiveClassService.getListOfliveClassesPaging(
                this.params,
                (result) => {
                    context.liveClasses = [];

                    if (result.success) {
                        this.total_data = result.data.total_Liveclass;
                        this.total_pages = result.data.max_page;

                        result.data.list_Liveclass.forEach(function (
                            group,
                            index
                        ) {
                            var level = group.level ? group.level : "-";
                            var createdAt = Moment(group.createdAt).format(
                                "YYYY-MM-DD"
                            );
                            var row = {
                                no: index,
                                id: group.classId,
                                name: group.name,
                                description: group.description,
                                subject: group.subject,
                                level: level,
                                grade: group.grade
                                    .toString()
                                    .replace(/[\[\]']+/g, ""),
                                createdAt: createdAt,
                                datas: group,
                            };
                            context.liveClasses.push(row);

                            context.isLoading = false;
                        });
                    }
                    context.isLoading = false;
                }
            );
        },

        async getTeachers() {
            const context = this;
            context.teacherList = [];

            return new Promise((resolve, reject) => {
                LiveClassService.getTeachers(function (result) {
                    if (result.success) {
                        context.teacherList = result.data;
                        resolve();
                    } else {
                        reject("Failed to fetch teachers");
                    }
                });
            });
        },

        createliveClass: function () {
            this.$router.push({ path: "/live-class/form" });
        },

        editliveClass: function () {
            var context = this;
            var groupId = this.selectedRow.id;
            context.$store.commit("live_class_init", this.selectedRow.datas);
            context.$router.push({
                path: "/live-class/form",
                query: { id: groupId },
            });
        },

        openNewTab: function () {
            var context = this;
            var groupId = context.selectedRow.id;
            context.$store.commit("live_class_init", this.selectedRow.datas);

            let routeData = context.$router.resolve({
                path: "/live-class/form",
                query: { id: groupId },
            });

            window.open(routeData.href, "_blank");
        },

        deleteliveClass: function (tryout) {
            var context = this;
            var groupId = tryout.id;

            LiveClassService.deleteLiveClass(groupId, function (result) {
                if (result.success) {
                    context.$store.commit("showAlert", {
                        message: `Berhasil menghapus data!`,
                        type: "success",
                    });
                    context.fetchData();
                }
                context.isLoading = false;
            });
        },

        reportLiveClass() {
            this.$router.push({ path: "/live-class-report" });
        },

        doFilter() {
            this.pagination.currentPage = 1;
            this.fetchData();
        },

        delByOneFilter(filter) {
            this.clearFilter();
            filter.value = "";
            var index = this.filters.push(filter) - 1;
            this.fetchData();
            this.filters.splice(index, 1);
        },

        clearFilter() {
            this.params = {
                page: 1,
                per_page: this.pagination.perPage,
                name: "",
                description: "",
                sort: "",
                subject: "",
                jenjang: "",
                grades: "",
            };
        },

        successUploadExcel() {
            this.dialogUploadLiveClass = false;
            this.fetchData();
        },

        finishUpload() {
            this.fetchData();
            this.dialogSucessUpload = false;
            this.dialogExcelError = false;

            sessionStorage.removeItem("error_upload_liveclass");
        },

        async uploadRowValidation(data) {
            var context = this;
            context.liveClassData = data;
            context.dialogUploadLiveClass = false;
            context.dialogExcelValidation = true;
            context.liveClassTotalCheckRow = 0;
            context.liveClassTotalErrorExcel = 0;
            context.progressUploadPresentation = 0;
            context.liveClassExcelError = [];

            const formatDate =
                /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
            const formatTime = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

            context.type_error = "validation_excel";
            var baris = 0;

            if (!data.length) {
                context.$store.commit("showAlert", {
                    message: "File excel tidak sesuai template",
                    type: "error",
                });

                context.dialogExcelValidation = false;
                return false;
            }

            try {
                // Checking header excel ------------------------------------------------------------------

                const arrObjExcel = Object.keys(data[0]);
                const arrHeaderExcel = [
                    "judul_live_class",
                    "deskripsi",
                    "mata_pelajaran_id",
                    "teacher_id",
                    "teacher_detail",
                    "youtube_url",
                    "roomPassword",
                    "jenjang",
                    "tipe",
                    "rombel_id",
                    "kelas",
                    "tanggal",
                    "waktu_mulai",
                    "waktu_berakhir",
                    "user_group",
                    "thumbnail_url",
                    "is_private",
                    "is_potrait",
                ];

                var field_match = 0;
                for (
                    var arr_excel = 0;
                    arr_excel < arrObjExcel.length;
                    arr_excel++
                ) {
                    for (
                        var arr_header = 0;
                        arr_header < arrHeaderExcel.length;
                        arr_header++
                    ) {
                        if (
                            arrObjExcel[arr_excel] ===
                            arrHeaderExcel[arr_header]
                        ) {
                            field_match++;
                        }
                    }
                }

                if (field_match < 10) {
                    context.$store.commit("showAlert", {
                        message: "File excel tidak sesuai template",
                        type: "error",
                    });

                    context.dialogExcelValidation = false;
                    return false;
                }
                // End Checking header excel ------------------------------------------------------------------

                for (const item of data) {
                    var error = "";
                    baris++;

                    if (!item.judul_live_class) {
                        error += "<b>judul_live_class</b> tidak diisi<br />";
                    }

                    if (!item.mata_pelajaran_id) {
                        error += "<b>mata_pelajaran_id</b> tidak diisi<br />";
                    }

                    if (!item.teacher_id) {
                        error += "<b>teacher_id</b> tidak diisi<br />";
                    }

                    if (!item.jenjang) {
                        error += "<b>jenjang</b> tidak diisi<br />";
                    }

                    if (!item.tipe) {
                        error += "<b>tipe</b> tidak diisi<br />";
                    }

                    if (!item.rombel_id) {
                        error += "<b>rombel_id</b> diisi<br />";
                    }

                    if (!item.kelas) {
                        error += "<b>kelas</b> tidak diisi<br />";
                    }

                    if (!item.tanggal) {
                        error += "<b>tanggal</b> tidak diisi<br />";
                    }

                    if (!item.waktu_mulai) {
                        error += "<b>waktu_mulai</b> tidak diisi<br />";
                    }

                    if (!item.waktu_berakhir) {
                        error += "<b>waktu_berakhir</b> tidak diisi<br />";
                    }

                    if (!item.user_group) {
                        error += "<b>user_group</b> tidak diisi<br />";
                    }

                    if (!item.thumbnail_url) {
                        error += "<b>thumbnail_url</b> tidak diisi<br />";
                    }

                    if (!item.rombel_id) {
                        error += "<b>rombel_id</b> tidak diisi<br />";
                    }

                    if (item.is_potrait === "" || item.is_potrait === null) {
                        error += "<b>is_potrait</b> tidak diisi<br />";
                    }

                    if (item.is_private === "" || item.is_private === null) {
                        error += "<b>is_private</b> tidak diisi<br />";
                    }

                    if (!item.is_potrait && item.is_potrait !== 0) {
                        error += "<b>is_potrait</b> tidak diisi<br />";
                    }

                    if (!item.is_private && item.is_private !== 0) {
                        error += "<b>is_private</b> tidak diisi<br />";
                    }

                    // Special Case Validation -------------------------------------------------------------------------------

                    if (
                        item.mata_pelajaran_id &&
                        !/^\d+$/.test(item.mata_pelajaran_id)
                    ) {
                        error +=
                            "<b>mata_pelajaran_id</b> harus sesuai dengan kode mapel<br />";
                    }

                    if (item.jenjang && !context.level.includes(item.jenjang)) {
                        error += "<b>jenjang</b> tidak sesuai<br />";
                    }

                    if (
                        item.tipe &&
                        !context.package_type.includes(item.tipe)
                    ) {
                        error += "<b>tipe</b> tidak sesuai<br />";
                    }

                    if (item.tanggal) {
                        if (!formatDate.test(item.tanggal)) {
                            error +=
                                "<b>tanggal</b> harus sesuai dengan format DD/MM/YYYY<br />";
                        }
                    }

                    if (item.waktu_mulai) {
                        if (!formatTime.test(item.waktu_mulai)) {
                            error +=
                                "<b>waktu_mulai</b> harus sesuai dengan format HH:MM:SS<br />";
                        }
                    }

                    if (item.waktu_berakhir) {
                        if (!formatTime.test(item.waktu_berakhir)) {
                            error +=
                                "<b>waktu_berakhir</b> harus sesuai dengan format HH:MM:SS<br />";
                        }
                    }

                    if (item.user_group) {
                        const userGroupList = item.user_group
                            .toString()
                            .split(",");
                        for (const user_group of userGroupList) {
                            if (!/^\d+$/.test(user_group)) {
                                error += `<b>user_group ${user_group}</b> tidak sesuai<br />`;
                            }
                        }
                    }

                    if (item.rombel_id) {
                        const rombelList = item.rombel_id.toString().split(",");
                        for (const rombel_id of rombelList) {
                            if (!/^\d+$/.test(rombel_id)) {
                                error += `<b>rombel_id ${rombel_id}</b> tidak sesuai<br />`;
                            }
                        }
                    }

                    if (item.kelas) {
                        const kelasList = item.kelas.toString().split(",");
                        for (const kelas of kelasList) {
                            if (!/^\d+$/.test(kelas)) {
                                error += `<b>kelas ${kelas}</b> tidak tersedia<br />`;
                            } else {
                                const numericKelas = Number(kelas);
                                if (
                                    item.jenjang === "SMA" &&
                                    (numericKelas < 10 || numericKelas > 12)
                                ) {
                                    error += `<b>kelas ${kelas}</b> tidak sesuai dengan jenjang<br />`;
                                }

                                if (
                                    item.jenjang === "SMP" &&
                                    (numericKelas < 7 || numericKelas > 9)
                                ) {
                                    error += `<b>kelas ${kelas}</b> tidak sesuai dengan jenjang<br />`;
                                }

                                if (
                                    item.jenjang === "SD" &&
                                    (numericKelas < 4 || numericKelas > 6)
                                ) {
                                    error += `<b>kelas ${kelas}</b> tidak sesuai dengan jenjang<br />`;
                                }
                            }
                        }
                    }

                    if (item.teacher_id) {
                        const teacherList = context.teacherList.map(
                            (teacher) => teacher.id
                        );
                        var teacherId = item.teacher_id
                            .toString()
                            .split(",")
                            .map(Number);

                        for (const teacher of teacherId) {
                            if (!teacherList.includes(teacher)) {
                                error += `<b>teacher_id ${teacher}</b> tidak tersedia<br />`;
                            }
                        }
                    }

                    if (item.waktu_mulai && item.waktu_berakhir) {
                        const start = new Date(
                            `1970-01-01T${item.waktu_mulai}Z`
                        );
                        const end = new Date(
                            `1970-01-01T${item.waktu_berakhir}Z`
                        );

                        if (start > end) {
                            error += `<b>waktu berakhir</b> lebih awal daripada <b>waktu mulai</b><br />`;
                        }
                    }

                    if (
                        item.is_private &&
                        !/^[01]$/.test(String(item.is_private))
                    ) {
                        error +=
                            "<b>is_private</b> hanya boleh bernilai 0 atau 1<br />";
                    }

                    if (
                        item.is_potrait &&
                        !/^[01]$/.test(String(item.is_potrait))
                    ) {
                        error +=
                            "<b>is_potrait</b> hanya boleh bernilai 0 atau 1<br />";
                    }

                    // End Special Case Validation -------------------------------------------------------------------------------

                    if (error) {
                        item.baris = baris;
                        item.error = error;
                        context.liveClassExcelError.push(item);
                        context.liveClassTotalErrorExcel++;
                    }

                    const timer = await context.timerUpload();
                    await new Promise((resolve) => setTimeout(resolve, timer));
                    context.liveClassTotalCheckRow++;
                }

                context.dialogExcelValidation = false;
                sessionStorage.removeItem("error_upload_liveclass");

                if (context.liveClassExcelError.length) {
                    context.dialogExcelError = true;
                } else {
                    context.uploadProcess();
                }
            } catch (error) {
                console.log(error);
            }
        },

        async uploadProcess() {
            var context = this;
            const data = context.liveClassData;
            context.liveClassTotalCheckRow = 0;
            context.liveClassTotalErrorExcel = 0;
            context.liveClassTotalSuccessExcel = 0;
            context.liveClassExcelError = [];
            context.dialogLoadingUpload = true;
            context.type_error = "upload_excel";
            var baris = 0;

            for (const item of data) {
                var process = await context.createLiveClassService(item);

                var process_status = process.status;
                var process_message = process.message;
                baris++;

                if (process_status === false) {
                    item.baris = baris;
                    item.error = process_message;
                    context.liveClassExcelError.push(item);
                    context.liveClassTotalErrorExcel++;

                    sessionStorage.setItem(
                        "error_upload_liveclass",
                        JSON.stringify(context.liveClassExcelError)
                    );
                } else {
                    context.liveClassTotalSuccessExcel++;
                }

                const timer = await context.timerUpload();
                await new Promise((resolve) => setTimeout(resolve, timer));
                context.liveClassTotalCheckRow++;
                context.progressUploadPresentation =
                    (context.liveClassTotalCheckRow /
                        context.liveClassData.length) *
                    100;
            }

            context.dialogLoadingUpload = false;
            if (context.liveClassTotalSuccessExcel < 1) {
                context.dialogExcelError = true;
            } else {
                context.dialogSucessUpload = true;
            }
        },

        async createLiveClassService(data) {
            var liveclass_date = Moment(data.tanggal, "DD/MM/YYYY").format(
                "YYYY-MM-DD"
            );

            var startedtime = liveclass_date + " " + data.waktu_mulai;
            var classOpened = Moment(startedtime).valueOf();
            var endedtime = liveclass_date + " " + data.waktu_berakhir;
            var classEnded = Moment(endedtime).valueOf();

            var user_group = data.user_group.toString().split(",").map(Number);
            var grade = data.kelas.toString().split(",").map(Number);
            var group_id = data.rombel_id.toString().split(",").map(Number);

            const teacher_id = data.teacher_id.split(",").map((id) => {
                const teacher =
                    this.teacherList.find((e) => Number(id) === e.id) || null;

                return {
                    id: Number(id),
                    teacher_name: teacher ? teacher.teacher_name : null,
                };
            });

            var dataCreate = {
                name: data.judul_live_class,
                description: data.deskripsi,
                subject: data.mata_pelajaran_id,
                teacherDetails: data.teacher_detail,
                teachers: teacher_id,
                youtubeUrl: data.youtube_url,
                roomPassword: data.roomPassword,
                level: data.jenjang,
                grade: grade,
                type: data.tipe,
                groupId: group_id,
                isPrivate: data.is_private === 1 ? true : false,
                thumbnail: data.thumbnail_url,
                startAt: classOpened,
                endAt: classEnded,
                user_group_id: data.user_group,
                user_group: user_group,
                is_special: data.is_potrait === 1 ? true : false,
                user_type: "student",
                // Defining but not used
                material_description: "",
                program_benefit: "",
                code: "",
                roomUrl: "",
                meetingId: "",
            };

            return new Promise((resolve) => {
                LiveClassService.createLiveClass(
                    dataCreate,
                    function (response) {
                        var result = {};

                        if (response.success) {
                            if (response.data.status === "200") {
                                result = {
                                    status: true,
                                    message: "Live Class berhasil di upload",
                                };
                            } else if (response.data.status === "205") {
                                result = {
                                    status: false,
                                    message: response.data.description,
                                };
                            }
                        } else {
                            result = {
                                status: false,
                                message:
                                    "Kesalahan server, data tidak dapat diproses",
                            };
                        }

                        resolve(result);
                    }
                );
            });
        },

        async timerUpload() {
            var timer = 0;
            if (
                this.liveClassData.length > 1 &&
                this.liveClassData.length <= 5
            ) {
                timer = 80;
            }

            if (
                this.liveClassData.length > 5 &&
                this.liveClassData.length <= 10
            ) {
                timer = 60;
            }

            if (
                this.liveClassData.length > 10 &&
                this.liveClassData.length <= 20
            ) {
                timer = 50;
            }

            if (
                this.liveClassData.length > 20 &&
                this.liveClassData.length <= 30
            ) {
                timer = 10;
            }

            if (
                this.liveClassData.length > 30 &&
                this.liveClassData.length <= 100
            ) {
                timer = 10;
            }

            return timer;
        },

        checkSessionErrorUpload() {
            var session = sessionStorage.getItem("error_upload_liveclass");
            if (session) {
                this.dialogConfirmErrorUpload = true;
            }
        },

        getSessionErrorUpload() {
            var error_excel = JSON.parse(session);
            this.type_error = "upload_excel";
            this.liveClassExcelError = error_excel;
            this.liveClassTotalErrorExcel = error_excel.length;
            this.dialogExcelError = true;
        },

        clearSessionErrorUpload() {
            sessionStorage.removeItem("error_upload_liveclass");
            this.dialogConfirmErrorUpload = false;
        },
    },
};
</script>



// WEBPACK FOOTER //
// LiveClass.vue?16f8c73b